( function( $ ) {

    $('document').ready(function(){
        // Burger nav
        $('.menu-toggle').on('click', function(){
            $('header').toggleClass('header--menu-is-open');
        });
        // Show sub-menu on click
        $('#primary-menu > li.menu-item-has-children > .arrow-more').on('click', function(e){
            let parent = $(this).parent('li');
            $('#primary-menu > li.menu-item-has-children').not(parent).removeClass('sub-menu-is-open');
            $(parent).toggleClass('sub-menu-is-open');
        });
        // Show sub-menu from sub-menu on click
        $('#primary-menu > li .sub-menu li.menu-item-has-children .arrow-more').on('click', function(f){
            let submenuParent = $(this).parent('li');
            $(submenuParent).toggleClass('sub-menu-is-open');
        });

        /*let pageHasMap  = $('.leaflet-marker-pane').length;
        let domain      = window.location.hostname;
        let imgPath     = domain + '/wp-content/themes/aptima/dist/js/marqueur.svg';
        console.log(imgPath);
        if ( pageHasMap > 0 ) {
            $('.leaflet-marker-pane img').attr('src', imgPath);
        }*/
    });

    $(window).scroll(function(){
        // Do things...
    });

}( jQuery ) );


// Animation Marqueur SVG
function callbackFunc(entries, observer) {
    entries.forEach(entry => {
        const intersecting = entry.isIntersecting;
        const paths = document.querySelectorAll('.tagline svg path');
        if ( intersecting ) {
            for (const path of paths) {
                path.classList.add('is-animating');
            }
        } else {
            for (const path of paths) {
                path.classList.remove('is-animating');
            }
        }
      })
    // observer.unobserve(document.querySelector('.tagline'));
}

let options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.3
}

let observer = new IntersectionObserver(callbackFunc, options);

const tagline = document.querySelector('.tagline');
if ( tagline !== null) {
    observer.observe(tagline);
}


// Animation Chiffres
function callbackFuncChiffres(entries, observer) {
    entries.forEach(entry => {
        const intersecting = entry.isIntersecting
        if ( intersecting ) {
            jQuery('.chiffre').each(function () {
                jQuery(this).prop('Counter',0).animate({
                    Counter: jQuery(this).text()
                }, {
                    duration: 1750,
                    easing: 'swing',
                    step: function (now) {
                        jQuery(this).text(Math.ceil(now));
                    }
                });
            });
            observer.unobserve(document.querySelector('.bk-chiffres-cles__container'));
        }
    })
}

let optionsChiffres = {
    root: null,
    rootMargin: '0px',
    threshold: 0.3
}

let observerChiffres = new IntersectionObserver(callbackFuncChiffres, optionsChiffres);

const chiffresCles = document.querySelector('.bk-chiffres-cles__container');
if ( chiffresCles !== null ) {
    observerChiffres.observe(chiffresCles);
}

// Animation Compétences
function callbackFuncSkills(entries, observer) {
    entries.forEach(entry => {
        const intersecting = entry.isIntersecting
        if ( intersecting ) {
            const skills = document.querySelectorAll('.bk-skills__skill');
            for (const skill of skills) {
                skill.classList.add('is-animating');
            }
            observer.unobserve(document.querySelector('.bk-skills__container'));
        }
    })
}

let optionsSkills = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5
}

let observerSkills = new IntersectionObserver(callbackFuncSkills, optionsSkills);

const skillsEl = document.querySelector('.bk-skills__container');
if ( skillsEl !== null ) {
    observerSkills.observe(skillsEl);
}